import Raven from 'raven-js';
import session from '../utils/session';


const logException = error => {
	const userSession = session.get('userData') || {};

	if (Object.keys(userSession).length) {
		const user = {
			id: userSession.id,
			name: userSession.name,
			email: userSession.email,
			username: userSession.username,
		};

		Raven.setUserContext(user);
	}
	Raven.captureException(error);
};

export default logException;
